import { GridLegacy as Grid } from '@mui/material';
import { Button } from '@rumblefish/ui/Rumblefish23Theme';
import React, { useMemo, useRef, useState } from 'react';
import type { CurrentOpeningsProps } from './CurrentOpenings.types';
import OpeningItem from './OpeningItem';
import {
  Expander,
  ExpanderContent,
  StyledGrid,
  StyledRoot,
  StyledSection,
  StyledSectionTitle,
} from './styles';

export const CurrentOpenings: React.FC<CurrentOpeningsProps> = ({ model }) => {
  const data = model;
  const [isExpanded, setIsExpanded] = useState(false);
  const [heightRatio, setHeightRatio] = useState('');
  const buttonLabel = useRef<string | null>(null);
  const filteredData = useMemo(() => {
    if (!isExpanded) {
      buttonLabel.current = 'Show More';
      const ratio = (1 / data.length) * 3;
      setHeightRatio(`${ratio}fr`);
      return data;
    } else {
      buttonLabel.current = 'Show Less';
      return data;
    }
  }, [data, isExpanded]);
  return (
    <StyledSection
      width="normal"
      sx={{ marginBottom: '6rem' }}
      id="current-openings">
      <StyledRoot>
        <Grid container>
          <StyledSectionTitle variant="display_sm">
            Job openings
          </StyledSectionTitle>
          {filteredData.length > 3 ? (
            <>
              <Grid item xs={12}>
                <Expander expanded={isExpanded} items={heightRatio}>
                  <ExpanderContent expanded={isExpanded}>
                    {filteredData?.map((opening) => (
                      <OpeningItem opening={opening} key={opening.documentId} />
                    ))}
                  </ExpanderContent>
                </Expander>
              </Grid>
              <StyledGrid item xs={12}>
                <Button
                  onClick={() => setIsExpanded(!isExpanded)}
                  secondaryVariant>
                  {' '}
                  {buttonLabel.current}
                </Button>
              </StyledGrid>
            </>
          ) : (
            <Grid item xs={12}>
              {filteredData?.map((opening) => (
                <OpeningItem opening={opening} key={opening.documentId} />
              ))}
            </Grid>
          )}
        </Grid>
      </StyledRoot>
    </StyledSection>
  );
};
